import { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import { isInWishlist, toggleWishlist } from "@/lib/wishlist.ts";

interface Props {
  productId: number;
  variant?: "icon" | "full";
  className?: string;
}

export function WishlistButton({ productId, variant = "icon", className = "" }: Props) {
  const [active, setActive] = useState(() => isInWishlist(productId));

  useEffect(() => {
    const handler = () => setActive(isInWishlist(productId));
    window.addEventListener("wishlist-change", handler);
    return () => window.removeEventListener("wishlist-change", handler);
  }, [productId]);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(productId);
  };

  if (variant === "full") {
    return (
      <button
        onClick={handleClick}
        className={`flex w-full items-center justify-center gap-2 border border-border py-4 text-sm font-medium tracking-wide transition-colors hover:bg-bg-alt ${className}`}
      >
        <Heart
          size={18}
          className={active ? "fill-accent text-accent" : "text-text"}
        />
        {active ? "Remove from Wishlist" : "Add to Wishlist"}
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className={`transition-colors ${className}`}
      aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
    >
      <Heart
        size={18}
        className={active ? "fill-accent text-accent" : "text-text-muted hover:text-text"}
      />
    </button>
  );
}
